// extracted by mini-css-extract-plugin
module.exports = {"card":"FAQItem_card__NQjwT","question":"FAQItem_question__OAGbR","answer":"FAQItem_answer__CiFOA"};